"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurriculumLearnosityIdsMap = exports.CurriculumPrefixForColorsMap = exports.CurriculumId = void 0;
exports.getCurriculumIds = getCurriculumIds;
exports.getSupportedCurriculums = getSupportedCurriculums;
exports.getCurriculumIdFromCurriculum = getCurriculumIdFromCurriculum;
exports.getLearnosityCurriculumIdsFromCurriculumId = getLearnosityCurriculumIdsFromCurriculumId;
exports.getCurriculumPrefixFromCurriculum = getCurriculumPrefixFromCurriculum;
exports.getCurriculumColorPrefix = getCurriculumColorPrefix;
exports.hideMakeCopy = hideMakeCopy;
var curriculumName_enum_1 = require("./curriculumName.enum");
var CurriculumId;
(function (CurriculumId) {
    CurriculumId["EurekaMath"] = "em";
    CurriculumId["EurekaMathTX"] = "emtx";
    CurriculumId["EurekaMathBBL"] = "embbl";
    CurriculumId["EurekaMath2"] = "em2";
    CurriculumId["EurekaMath2CA"] = "em2ca";
    CurriculumId["EurekaMath2CARev"] = "em2carev";
    CurriculumId["EurekaMath2LA"] = "em2la";
    CurriculumId["EurekaMath2UTE"] = "em2ute";
    CurriculumId["EurekaMath2FL"] = "em2fl";
    CurriculumId["EurekaMath2NY"] = "em2ny";
    CurriculumId["EurekaMath2TN"] = "em2tn";
    CurriculumId["WitAndWisdom"] = "ww";
    CurriculumId["WitAndWisdomDTE"] = "wwdte";
    CurriculumId["WitAndWisdomFL"] = "wwfl";
    CurriculumId["WitAndWisdomOR"] = "wwor";
    CurriculumId["PhDScience"] = "phd";
    CurriculumId["PhDScienceTX"] = "phdtexas";
    CurriculumId["PhDScienceCA"] = "phdca";
    CurriculumId["PhDScienceNAT"] = "phdnat";
    CurriculumId["PhDScienceNAT25"] = "phdnat25";
    CurriculumId["PhdGMAA"] = "phdGMAA";
    CurriculumId["PhDPilot"] = "phdpilot";
    CurriculumId["ArtsAndLetters"] = "al";
    CurriculumId["Geodes"] = "geo";
    CurriculumId["GeodesInsync"] = "geodes";
    CurriculumId["Digital"] = "digital";
    CurriculumId["Other"] = "other";
})(CurriculumId || (exports.CurriculumId = CurriculumId = {}));
exports.CurriculumPrefixForColorsMap = new Map([
    [CurriculumId.EurekaMath, CurriculumId.EurekaMath],
    [CurriculumId.PhDScience, CurriculumId.PhDScience],
    // Arts and Letters pending to be added as is currently causing an error.
    [CurriculumId.WitAndWisdom, CurriculumId.WitAndWisdom],
    [CurriculumId.WitAndWisdom, CurriculumId.WitAndWisdom],
]);
exports.CurriculumLearnosityIdsMap = new Map([
    [CurriculumId.EurekaMath, [curriculumName_enum_1.CurriculumName.EurekaMath, CurriculumId.EurekaMath]],
    [CurriculumId.EurekaMathBBL, [curriculumName_enum_1.CurriculumName.EurekaMathBBL, CurriculumId.EurekaMathBBL]],
    [CurriculumId.EurekaMathTX, [curriculumName_enum_1.CurriculumName.EurekaMathTX, CurriculumId.EurekaMathTX]],
    [CurriculumId.EurekaMath2, [curriculumName_enum_1.CurriculumName.EurekaMath2, CurriculumId.EurekaMath2]],
    [CurriculumId.EurekaMath2CA, [curriculumName_enum_1.CurriculumName.EurekaMath2CA, CurriculumId.EurekaMath2CA]],
    [CurriculumId.EurekaMath2CARev, [curriculumName_enum_1.CurriculumName.EurekaMath2CARev, CurriculumId.EurekaMath2CARev]],
    [CurriculumId.PhdGMAA, [curriculumName_enum_1.CurriculumName.PhdGMAA, CurriculumId.PhdGMAA]],
    [CurriculumId.EurekaMath2LA, [curriculumName_enum_1.CurriculumName.EurekaMath2LA, CurriculumId.EurekaMath2LA]],
    [CurriculumId.EurekaMath2FL, [curriculumName_enum_1.CurriculumName.EurekaMath2FL, CurriculumId.EurekaMath2FL]],
    [CurriculumId.EurekaMath2NY, [curriculumName_enum_1.CurriculumName.EurekaMath2NY, CurriculumId.EurekaMath2NY]],
    [CurriculumId.EurekaMath2UTE, [curriculumName_enum_1.CurriculumName.EurekaMath2UTE, CurriculumId.EurekaMath2UTE]],
    [CurriculumId.EurekaMath2TN, [curriculumName_enum_1.CurriculumName.EurekaMath2TN, CurriculumId.EurekaMath2TN]],
    [CurriculumId.WitAndWisdom, [curriculumName_enum_1.CurriculumName.WitAndWisdom, CurriculumId.WitAndWisdom]],
    [CurriculumId.WitAndWisdomDTE, [curriculumName_enum_1.CurriculumName.WitAndWisdomDTE, CurriculumId.WitAndWisdomDTE]],
    [CurriculumId.WitAndWisdomFL, [curriculumName_enum_1.CurriculumName.WitAndWisdomFL, CurriculumId.WitAndWisdomFL]],
    [CurriculumId.WitAndWisdomOR, [curriculumName_enum_1.CurriculumName.WitAndWisdomOR, CurriculumId.WitAndWisdomOR]],
    [CurriculumId.PhDScience, [curriculumName_enum_1.CurriculumName.PhDScience, CurriculumId.PhDScience]],
    [CurriculumId.PhDScienceTX, [curriculumName_enum_1.CurriculumName.PhDScienceTX, CurriculumId.PhDScienceTX]],
    [CurriculumId.PhDScienceCA, [curriculumName_enum_1.CurriculumName.PhDScienceCA, CurriculumId.PhDScienceCA]],
    [CurriculumId.PhDScienceNAT, [curriculumName_enum_1.CurriculumName.PhDScienceNAT, CurriculumId.PhDScienceNAT]],
    [CurriculumId.PhDScienceNAT25, [curriculumName_enum_1.CurriculumName.PhDScienceNAT25, CurriculumId.PhDScienceNAT25]],
    [CurriculumId.PhDPilot, [curriculumName_enum_1.CurriculumName.PhDPilot, CurriculumId.PhDPilot]],
    [CurriculumId.ArtsAndLetters, [curriculumName_enum_1.CurriculumName.ArtsAndLetters, CurriculumId.ArtsAndLetters]],
    [CurriculumId.Geodes, [curriculumName_enum_1.CurriculumName.Geodes, CurriculumId.Geodes]],
    [CurriculumId.Other, [CurriculumId.Other]],
]);
function getCurriculumIds() {
    return Object.values(CurriculumId);
}
function getSupportedCurriculums() {
    return [
        CurriculumId.WitAndWisdom,
        CurriculumId.EurekaMath,
        CurriculumId.EurekaMathBBL,
        CurriculumId.EurekaMathTX,
        CurriculumId.EurekaMath2,
        CurriculumId.EurekaMath2UTE,
        CurriculumId.EurekaMath2CA,
        CurriculumId.EurekaMath2CARev,
        CurriculumId.EurekaMath2LA,
        CurriculumId.EurekaMath2FL,
        CurriculumId.EurekaMath2NY,
        CurriculumId.EurekaMath2TN,
        CurriculumId.PhDScienceTX,
        CurriculumId.PhDScienceNAT25,
        CurriculumId.WitAndWisdomDTE,
        CurriculumId.WitAndWisdomFL,
        CurriculumId.WitAndWisdomOR,
        CurriculumId.ArtsAndLetters,
    ];
}
function getCurriculumIdFromCurriculum(curriculum) {
    return getCurriculumIds().find(function (type) { return type === curriculum; });
}
function getLearnosityCurriculumIdsFromCurriculumId(curriculumId) {
    return exports.CurriculumLearnosityIdsMap.get(curriculumId)
        ? exports.CurriculumLearnosityIdsMap.get(curriculumId)
        : [];
}
function getCurriculumPrefixFromCurriculum(value) {
    var curriculumPrefix = getCurriculumIds().find(function (prefix) { return value.startsWith(prefix); });
    return curriculumPrefix !== undefined ? curriculumPrefix : CurriculumId.EurekaMath;
}
// This is used for now to prevent the app from breaking
// when no prefix is found for a new curriculum and looking for
// Colors.Curriculum[curriculum].main in DpGradeCollapse.styled.tsx
// in teacher UI
function getCurriculumColorPrefix(value) {
    var curriculumPrefix = getCurriculumPrefixFromCurriculum(value);
    var colorPrefix = exports.CurriculumPrefixForColorsMap.get(curriculumPrefix);
    return colorPrefix !== undefined
        ? colorPrefix
        : // Using WW as default value to prevent FE from crashing.
            exports.CurriculumPrefixForColorsMap.get(CurriculumId.WitAndWisdom);
}
function hideMakeCopy(curriculum) {
    var curriculaToHide = [
        CurriculumId.ArtsAndLetters,
        CurriculumId.PhDScienceNAT25,
        CurriculumId.WitAndWisdom,
        CurriculumId.WitAndWisdomDTE,
        CurriculumId.WitAndWisdomFL,
        CurriculumId.WitAndWisdomOR,
    ];
    return curriculaToHide.includes(curriculum);
}
